module.exports = "#root {\n  height: 100%;\n  left: 0;\n  overflow: auto;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src-docs/app/snippets/example-rw-02.css
 ** module id = 125
 ** module chunks = 1
 **/